/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Link } from 'react-router-dom';
import LinkButton from 'components/Components/UI/LinkButton';
import PropTypes from 'prop-types';
import Modal from 'components/Components/UI/Modal';
import { getImgAltText } from 'utils/alt-attribute-helper';
import isFunction from 'lodash/isFunction';
import CarouselSliderImage from '../CarouselSliderImage';
import clsx from "clsx";

class SquareListElem extends Component
{
    static displayName = 'SquareListElem';

    constructor(props)
    {
        super(props);

        this.handleOpenModalReadMore = this.handleOpenModalReadMore.bind(this);
        this.handleCloseModalReadMore = this.handleCloseModalReadMore.bind(this);

        this.state = {
            showModalReadMore: false,
            revealed: false,
        };
    }

    handleOpenModalReadMore()
    {
        this.setState({ showModalReadMore: true });
    }

    handleCloseModalReadMore()
    {
        this.setState({ showModalReadMore: false });
    }

    render()
    {
        const {
            link, image, title, subtitle, description, rooms, images, callToActionButton,
        } = this.props;

        let [
            renderSubtitle, renderOverlay,
        ] = '';

        let renderLink = <Link to={link} />;

        let renderBtn = (
            <LinkButton
                text="View more"
                link={link}
                className="tw-w-full"
                color="gray"
            />
        );

        if (rooms >= 0)
        {
            renderOverlay = (
                <div className="list-square-item-image-overlay tw-py-6 tw-px-10 tw-hidden md:tw-block">
                    <div className="tw-flex tw-flex-wrap">
                        <div className="tw-w-1/2">
                            <p className="tw-uppercase font-sp tw-mb-2">Rating</p>
                            <p className="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl">5/5</p>
                        </div>
                        {
                            rooms !== 0
                            && (
                                <div className="tw-w-1/2">
                                    <p className="tw-uppercase font-sp tw-mb-2">Room Types</p>
                                    <p className="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl">{rooms}</p>
                                </div>
                            )
                        }

                    </div>
                </div>
            );
        }

        if (subtitle)
        {
            renderSubtitle = <h4 className="tw-uppercase font-sp tw-mb-4 lg:tw-mb-6">{subtitle}</h4>;
        }

        else
        {
            if (description)
            {
                renderSubtitle = <h4 className="tw-mb-4 lg:tw-mb-6 tw-mt-4">{`${description.replace(/(<([^>]+)>)/ig, ' ').slice(0, 80)} ...`}</h4>;
            }

            renderLink = (
                <Link
                    to={link}
                    onClick={!link ? this.handleOpenModalReadMore : null}
                />
            );

            renderBtn = (
                <LinkButton
                    text="Read more"
                    onClick={!link ? this.handleOpenModalReadMore : null}
                    className="tw-w-full"
                    color="gray"
                    link={link || '#'}
                />
            );
        }

        return (
            <React.Fragment>
                <Fade bottom onReveal={() => this.setState({ revealed: true })}>
                    <div className="tw-w-full md:tw-w-1/2 xl:tw-w-1/3 md:tw-px-4 xl:tw-px-5 tw-mb-12 md:tw-mb-24 tw-flex tw-flex-wrap">
                        <div className="list-square-item-image tw-w-full h-fit-content">
                            {renderLink}
                            {this.state.revealed && <img loading="lazy" src={image} alt={getImgAltText(title)} />}
                            {renderOverlay}
                        </div>
                        <div className="tw-flex tw-content-between tw-flex-wrap tw-w-full">
                            <div className="tw-w-full">
                                <h4 className="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl tw-mt-8 tw-mb-2">{title}</h4>
                                {renderSubtitle}
                            </div>
                            <div className="tw-w-full">
                                <div className="tw-flex tw-flex-wrap">
                                    {callToActionButton && (
                                        <div className="tw-w-full xl:tw-w-1/2 xl:tw-pr-3">
                                            {callToActionButton}
                                        </div>
                                    )}

                                    {isFunction(this.props.onClickQuote) && (
                                        <div className="tw-w-full xl:tw-w-1/2 xl:tw-pr-3">
                                            <LinkButton text="Quote" onClick={this.props.onClickQuote} link="#" className="tw-w-full" color="orange" />
                                        </div>
                                    )}
                                    <div className={clsx('tw-w-full xl:tw-w-1/2 xl:tw-pl-3 tw-mt-2 xl:tw-mt-0', (!isFunction(this.props.onClickQuote) && !callToActionButton) && 'xl:tw-w-full xl:tw-pl-0')}>
                                        {renderBtn}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fade>

                {/* Modal Read More for Rooms */}
                <Modal
                    isOpen={this.state.showModalReadMore}
                    modalTitle={title}
                >
                    <Link className="modal-close-btn tw-text-gray-700 hover:tw-text-orange-400" to="#" onClick={this.handleCloseModalReadMore}>
                        <span className="tw-uppercase font-sp">Close</span>
                        <span className="material-icons tw-align-middle tw-ml-2">close</span>
                    </Link>
                    <div className="tw-text-left tw-flex tw-flex-wrap tw-mt-8 md:tw-mt-16">
                        <div className="tw-w-full md:tw-px-24 tw-mb-8">
                            <p className="tw-uppercase font-sp tw-mb-4">Description</p>
                            <p>{description}</p>
                        </div>
                        <div className="tw-w-full">
                            {
                                images && images.length > 0
                                    && (
                                        <CarouselSliderImage
                                            images={images}
                                            element={title}
                                        />
                                    )
                            }
                        </div>
                    </div>
                    <LinkButton
                        text="Close"
                        onClick={this.handleCloseModalReadMore}
                        link="#"
                        className="tw-w-auto tw-mt-10"
                        color="gray"
                    />
                </Modal>
            </React.Fragment>
        );
    }
}

SquareListElem.defaultProps = {
    link: '#',
};

SquareListElem.propTypes = {
    image: PropTypes.node.isRequired,
    title: PropTypes.node.isRequired,
    link: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    rooms: PropTypes.number,
    images: PropTypes.array,
    onClickQuote: PropTypes.func,
    callToActionButton: PropTypes.element,
};

export default SquareListElem;
